import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onBeforeMount, onMounted, ref } from 'vue';
import { StubEnum } from './enums';
import {
  AccessDeniedTask,
  InvalidUrl,
  QueueDeleted,
  TaskNotFound,
  WorkspaceRemoval,
} from './components';
import { useRouter } from 'vue-router';
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from 'tir-components';
import { ArrowUturnLeftIcon } from 'tir-style-system/icons/outline';

/**Роутер */

export default /*#__PURE__*/_defineComponent({
  __name: 'stub-page',
  setup(__props) {

const router = useRouter();

/**код ошибки */
const errorCode = ref(router.currentRoute.value.query.errorCode as string);

/**Перед рендером компонента */
onBeforeMount(() => {
  if (!errorCode.value) router.back();
});
/**После рендера компонента */
onMounted(() => {
  router.replace({ query: { errorCode: undefined } });
});

/**Отображение заглушки взависимости от кода ошибки */
const getStubByErrorCode = computed(() => {
  switch (errorCode.value) {
    case StubEnum.WorkspaceRemoval:
    case StubEnum.QueueAccessDenied:
      return WorkspaceRemoval;
    case StubEnum.QueueDeleted:
      return QueueDeleted;
    case StubEnum.TaskNotFound:
      return TaskNotFound;
    case StubEnum.InvalidUrl:
      return InvalidUrl;
    default:
      return AccessDeniedTask;
  }
});

/**Вернуться назад */
const goBack = () => {
  router.push({ name: 'project-namespaces' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmButton), {
      size: _unref(TirPmButtonSizeEnum).Regular,
      variant: _unref(TirPmButtonVariantEnum).SecondaryState,
      onClick: goBack
    }, {
      leftSlot: _withCtx(() => [
        _createVNode(_unref(ArrowUturnLeftIcon))
      ]),
      _: 1
    }, 8, ["size", "variant"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(getStubByErrorCode.value)))
  ], 64))
}
}

})